export default __webpack_public_path__ + "static/media/tg.9b366870.png";